import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../helpers/axiosInstance";

export interface VolunteerCertificate {
  date: string;
  shortId: string;
  name: string;
  dept: string;
  email: string;
  registrationId: string;
  status: boolean;
}

interface UsersState {
  data: VolunteerCertificate[];
  loading: boolean;
  error: string | null;
}

const initialState: UsersState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchEventCertificates = createAsyncThunk(
  "volunteer/fetchEventCertificates",
  async (eventId: number | string | null, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`api/eventregistration/certificates/${eventId}`);
      return response.data as VolunteerCertificate[];
    } catch (error) {
      return rejectWithValue("Failed to fetch users");
    }
  },
);

const EventCertificateSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEventCertificates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEventCertificates.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchEventCertificates.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "Something went wrong";
      });
  },
});

export default EventCertificateSlice.reducer;
